import ProfileRedirect from './ProfileRedirect'

export default ProfileRedirect
